import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

interface UseEstablishmentUserRequestPasswordResetProps {
  userId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useEstablishmentUserRequestPasswordReset = ({ userId, onSuccess, onError }: UseEstablishmentUserRequestPasswordResetProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['establishmentUsersRequestPasswordReset', userId],
    mutationFn: async () => {
      return await privateAxios.put(`/establishment/users/${userId}/request_password_reset`);
    },
    onSuccess,
    onError,
  });
};
